import { watch } from "vue"
import { setContact } from '@app/memberships/state/partials/helpers/watches/details/watchMembershipTypeDetails'

/**
 * Creates a watch to fill in the member details from the form when a member is updated
 * 
 * @param {Object} data 
 * @param {Object} form 
 * @returns {Function} cancels the watch when executed
 */
export function createMemberDetailsWatch(data, form){
    /**
     * If we ever update the held member details we should reflect that change in the details of their member types on the form
     */
    return watch(
        data.member.details,
        (memberDetails) => {
            if(memberDetails.individual_member){
                form.fields.value.forename    = memberDetails.individual_member?.forename
                form.fields.value.middle_name = memberDetails.individual_member?.middle_name
                form.fields.value.surname     = memberDetails.individual_member?.surname

                setContact(form, memberDetails.individual_member.contact, true)
            } else if(memberDetails.organisation_member){
                const names = String(memberDetails.organisation_member?.name).split(' ')

                form.fields.value.forename = names.shift()
                form.fields.value.surname  = names.pop()
                form.fields.value.middle_name = names.join(' ')

                setContact(form, memberDetails.organisation_member.contact, true)
            }
        }
    )
}